// @ts-nocheck

/* Smart Cart "shop now" tabs — single source of truth.
   Each entry maps a tab to its Rebuy cross-sell widget (component id). The
   Rebuy custom template v-for's over this for BOTH the tab buttons and the
   widget panels, so they stay in sync. Add/remove/reorder a tab here only.
   (Set synchronously at file top so it exists before Rebuy renders the cart.) */
window.BLENDERS_SHOP_NOW_TABS = [
  // key: unique slug (used for the #shop-now-<key> panel + data-rebuy-list)
  // label: tab text
  // widgetId: the NUMERIC Rebuy widget id (the data-rebuy-id value for that widget)
  { key: 'men', label: 'Men', widgetId: 191377 },
  { key: 'women', label: 'Women', widgetId: 191378 },
  { key: 'youth', label: 'Youth', widgetId: 296354 },
  { key: 'snow', label: 'Snow', widgetId: 191379 },
];

/* Tab switcher for the shop-now picker. Self-contained (called from the
   template's inline v-on:click) so it works with the v-for-generated tabs/
   panels and doesn't depend on Rebuy's custom JS binding to static nodes. */
window.blendersShopNowTab = function (key) {
  var cart = document.getElementById('rebuy-cart');
  if (!cart) return;
  cart.querySelectorAll('.shop-now-list').forEach(function (li) {
    li.classList.toggle('active', li.getAttribute('data-rebuy-list') === key);
  });
  cart.querySelectorAll('.shop-now-rebuy-products > [id^="shop-now-"]').forEach(function (panel) {
    panel.style.display = panel.id === 'shop-now-' + key ? '' : 'none';
  });
};

/* Numeric Rebuy widget id whose products fill the per-item "Bundle with
   Add-ons" accordion body (e.g. the accessories / bundle widget). null = the
   accordion opens empty until set. The 20% discount itself is configured in
   Rebuy/Shopify, not here. */
window.BLENDERS_BUNDLE_ADDON_WIDGET_ID = 296533;

/* Expand/collapse the per-item "Bundle with Add-ons" accordion (toggles the
   + / − icon and shows/hides the add-on list via the .is-open class). */
window.blendersSetBundleHeight = function (bundle, open) {
  var body = bundle && bundle.querySelector('.rebuy-cart__bundle-body');
  if (!body) return;
  body.style.maxHeight = open ? (body.scrollHeight + 'px') : '0px';
};

window.blendersBundleToggle = function (event) {
  var bundle = event && event.currentTarget && event.currentTarget.closest('.rebuy-cart__bundle');
  if (!bundle) return;
  var opening = !bundle.classList.contains('is-open');
  bundle.classList.toggle('is-open', opening);
  window.blendersSetBundleHeight(bundle, opening);
};

/* Footer summary (Figma 70:3127): the collapsed "Total :" row's chevron toggles
   the Subtotal/Shipping breakdown via .is-open on .rebuy-cart__flyout-summary. */
window.blendersSummaryToggle = function (event) {
  var summary = event && event.currentTarget && event.currentTarget.closest('.rebuy-cart__flyout-summary');
  if (summary) summary.classList.toggle('is-open');
};

/* Standard shipping rate (in DOLLARS) shown in the footer breakdown when the cart
   is UNDER the free-shipping threshold; once the progress bar hits 100% (threshold
   met) it shows FREE instead. Set null to always show FREE. */
window.BLENDERS_STANDARD_SHIPPING = 4.99;

/* RX line item (Figma 59:1252 / 59:1292): the "Details" toggle reveals the
   prescription breakdown (Lens Type/Color/Upgrade) via .rx-open on the
   .rebuy-cart__flyout-item; flips the Details/Close label + chevron. */
window.blendersRxToggle = function (event) {
  var item = event && event.currentTarget && event.currentTarget.closest('.rebuy-cart__flyout-item');
  if (item) item.classList.toggle('rx-open');
};

window.BLENDERS_MYSTERY_PAIR_HANDLE = 'mystery-pair';
window.BLENDERS_MYSTERY_PAIR = {
  /* Thumbnail (shown in the block) + per-shape frame images on Shopify Files. */
  image: 'https://cdn.shopify.com/s/files/1/0148/9585/files/BLENDERS_2023_Mystery-Pair_1440x720_1_e02bd455-a41e-4ef0-a51d-88d6160eb967.jpg?v=1689283975',
  genders: [
    { key: 'unisex', label: 'Unisex', value: 'Unisex' },
    { key: 'men', label: 'Men', value: 'Male' },
    { key: 'women', label: 'Women', value: 'Female' }
  ],
  shapes: [
    { key: 'square', label: 'Square', value: 'Square', image: 'https://cdn.shopify.com/s/files/1/0148/9585/files/mystery-shape-square.png?v=1781931441' },
    { key: 'rectangular', label: 'Rectangular', value: 'Rectangular', image: 'https://cdn.shopify.com/s/files/1/0148/9585/files/mystery-shape-rectangular.png?v=1781929667' },
    { key: 'oversized', label: 'Oversized', value: 'Oversized', image: 'https://cdn.shopify.com/s/files/1/0148/9585/files/Millenia_DX_Black_front.png?v=1773193265' }
  ]
};

window.BLENDERS_BLUE_MYSTERY_HANDLE = 'blue-light-mystery-pair';
window.BLENDERS_BLUE_MYSTERY = {
  image: 'https://cdn.shopify.com/s/files/1/0148/9585/files/BLENDERS_2023_Mystery-Pair_1440x720_1_c8e36ef4-f04c-4bed-8dbd-c3ca5a5a9a47.jpg?v=1781904331',
  shapes: [
    { key: 'square', label: 'Square', value: 'Square', image: 'https://cdn.shopify.com/s/files/1/0148/9585/files/blue-mystery-shape-square.png?v=1788555774' },
    { key: 'rectangular', label: 'Rectangular', value: 'Rectangular', image: 'https://cdn.shopify.com/s/files/1/0148/9585/files/blue-mystery-shape-rectangular.png?v=1788555773' },
    { key: 'round', label: 'Round', value: 'Round', image: 'https://cdn.shopify.com/s/files/1/0148/9585/files/blue-mystery-shape-round.png?v=1788555773' }
  ]
};

window.BLENDERS_MYSTERY_BLOCKS = {
  mystery: {
    handle: window.BLENDERS_MYSTERY_PAIR_HANDLE,
    config: window.BLENDERS_MYSTERY_PAIR,
    variantMap: 'BLENDERS_MYSTERY_VARIANTS'
  },
  blue: {
    handle: window.BLENDERS_BLUE_MYSTERY_HANDLE,
    config: window.BLENDERS_BLUE_MYSTERY,
    variantMap: 'BLENDERS_BLUE_MYSTERY_VARIANTS'
  }
};

window.BLENDERS_MYSTERY_HANDLES = [
  window.BLENDERS_MYSTERY_PAIR_HANDLE,
  window.BLENDERS_BLUE_MYSTERY_HANDLE
];

window.__blendersMystery = {};

function blendersMysteryBlock(kind) {
  return (window.BLENDERS_MYSTERY_BLOCKS || {})[kind || 'mystery'] || null;
}

/* Cart theme setting "Blue light mystery pair deal" (settings.show_blue_light_mystery_pair,
   emitted as window.BLENDERS_BLUE_MYSTERY_ENABLED by snippets/mystery-variant-map.liquid).
   When off the blue block is hidden by CSS (.blenders-hide-blue-mystery on <html>) and its
   picker/add are inert here too, so a Rebuy render can never add the product. Defaults to
   enabled when the flag is missing (e.g. cached page without the snippet). */
function blendersMysteryEnabled(kind) {
  if ((kind || 'mystery') !== 'blue') return true;
  return window.BLENDERS_BLUE_MYSTERY_ENABLED !== false;
}

function blendersMysteryEl(kind) {
  if (!blendersMysteryEnabled(kind)) return null;
  var cart = document.getElementById('rebuy-cart');
  if (!cart) return null;
  var k = kind || 'mystery';
  return cart.querySelector('.rebuy-cart__mystery[data-mystery-kind="' + k + '"]') ||
    (k === 'mystery' ? cart.querySelector('.rebuy-cart__mystery:not([data-mystery-kind])') : null);
}

function blendersMysteryState(kind) {
  var k = kind || 'mystery';
  if (!window.__blendersMystery[k]) {
    var genders = ((blendersMysteryBlock(k) || {}).config || {}).genders || [];
    window.__blendersMystery[k] = { gender: genders.length ? genders[0].key : null, shape: null };
  }
  return window.__blendersMystery[k];
}

window.blendersMysterySelectGender = function (key, kind) {
  blendersMysteryState(kind).gender = key;
  var block = blendersMysteryEl(kind);
  if (!block) return;
  block.querySelectorAll('.rebuy-cart__mystery-gender').forEach(function (el) {
    el.classList.toggle('active', el.getAttribute('data-gender') === key);
  });
};

window.blendersMysterySelectShape = function (key, kind) {
  blendersMysteryState(kind).shape = key;
  var block = blendersMysteryEl(kind);
  if (!block) return;
  block.querySelectorAll('.rebuy-cart__mystery-shape').forEach(function (el) {
    el.classList.toggle('active', el.getAttribute('data-shape') === key);
  });
  var add = block.querySelector('.rebuy-cart__mystery-add');
  if (add) add.disabled = !key;
};

/* Re-render the open Rebuy SmartCart after a raw Shopify cart mutation. Rebuy's
   refresh entrypoint varies by version — try the known ones in order (FIRST match
   wins, so we make at most one cart re-fetch, no burst). Falls back to the
   cart-change events the theme/Rebuy listen for. */
window.blendersRefreshRebuyCart = function () {
  try {
    var sc = window.Rebuy && window.Rebuy.SmartCart;
    var inst = sc && sc.instances && sc.instances[0];
    var targets = [
      [inst, 'reloadCart'], [inst, 'fetchCart'], [inst, 'getCart'], [inst, 'refresh'],
      [inst, 'update'], [inst, 'render'], [sc, 'reloadCart'], [sc, 'fetchCart'], [sc, 'refresh']
    ];
    for (var i = 0; i < targets.length; i++) {
      var o = targets[i][0], m = targets[i][1];
      if (o && typeof o[m] === 'function') { o[m](); return; }
    }
  } catch (e) {}
  ['rebuy:cart.change', 'rebuy:cart.refresh', 'cart:refresh', 'cart:build', 'cart:updated']
    .forEach(function (ev) { try { document.dispatchEvent(new CustomEvent(ev)); } catch (e) {} });
};

/* Fetch with retry on 429 (Shopify rate-limit) — honors Retry-After, backs off. */
function blendersFetchRetry(url, opts, attempts) {
  attempts = attempts == null ? 3 : attempts;
  return fetch(url, opts).then(function (r) {
    if (r.status === 429 && attempts > 1) {
      var wait = (parseFloat(r.headers.get('Retry-After')) || 1) * 1000;
      return new Promise(function (res) { setTimeout(res, wait); })
        .then(function () { return blendersFetchRetry(url, opts, attempts - 1); });
    }
    return r;
  });
}

window.__blendersMysteryProductPromises = {};
function blendersMysteryFetchProduct(handle) {
  if (!handle) return Promise.reject(new Error('no mystery handle'));
  if (window.__blendersMysteryProductPromises[handle]) return window.__blendersMysteryProductPromises[handle];

  window.__blendersMysteryProductPromises[handle] = blendersFetchRetry('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } }, 1)
    .then(function (r) { if (!r.ok) throw new Error('product fetch failed (' + r.status + ')'); return r.json(); })
    .catch(function (e) { delete window.__blendersMysteryProductPromises[handle]; throw e; });
  return window.__blendersMysteryProductPromises[handle];
}

function blendersMysteryResolveVariant(product, genderValue, shapeValue) {
  var vs = (product && product.variants) || [];
  for (var i = 0; i < vs.length; i++) {
    var opts = vs[i].options || [];
    if (opts.indexOf(shapeValue) === -1) continue;
    if (!genderValue || opts.indexOf(genderValue) !== -1) return vs[i];
  }
  return null;
}
function blendersMysteryOptionValue(arr, key) {
  if (!key) return null;
  for (var i = 0; i < arr.length; i++) { if (arr[i].key === key) return arr[i].value || arr[i].label; }
  return key;
}

function blendersMysteryMappedVariant(mapName, genderValue, shapeValue) {
  var map = mapName && window[mapName];
  if (!map) return null;
  if (!genderValue) return map[shapeValue] || null;
  return map[genderValue + '|' + shapeValue] || map[shapeValue + '|' + genderValue] || null;
}

window.blendersMysteryAdd = function (kind) {
  var k = kind || 'mystery';
  if (!blendersMysteryEnabled(k)) return; // block turned off in theme settings
  var s = blendersMysteryState(k);
  if (!s.shape) return; // need a chosen shape
  var block = blendersMysteryEl(k);
  var btn = block && block.querySelector('.rebuy-cart__mystery-add');
  if (btn && btn.dataset.adding === '1') return; // already adding

  // Same as the PDP add-to-cart button (animateAddToCart): flip to "✓ Added"
  // IMMEDIATELY on click, then revert after 2s. Don't set textContent (it would
  // wipe the label spans the animation cross-fades). Disabled state follows the
  // shape selection (so the revert keeps it disabled once we reset the picker).
  if (btn) {
    btn.dataset.adding = '1';
    btn.classList.add('is-added');
    btn.disabled = true;
    setTimeout(function () {
      if (!btn || !document.body.contains(btn)) return;
      btn.classList.remove('is-added');
      btn.disabled = !blendersMysteryState(k).shape;
      delete btn.dataset.adding;
    }, 2000);
  }
  var revert = function () {
    if (!btn || !document.body.contains(btn)) return;
    btn.classList.remove('is-added');
    btn.disabled = !blendersMysteryState(k).shape;
    delete btn.dataset.adding;
  };

  var reg = blendersMysteryBlock(k) || {};
  var cfg = reg.config || { genders: [], shapes: [] };
  var genderValue = blendersMysteryOptionValue(cfg.genders || [], s.gender);
  var shapeValue = blendersMysteryOptionValue(cfg.shapes || [], s.shape);

  var addVariant = function (variantId) {
    return blendersFetchRetry('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed (' + r.status + ')'); return r.json(); })
      .then(function () {
        window.blendersRefreshRebuyCart();
        window.blendersMysteryResetPicker(k); // return to the initial picker state
      });
  };

  var mapped = blendersMysteryMappedVariant(reg.variantMap, genderValue, shapeValue);
  if (mapped) {
    addVariant(mapped).catch(function () { revert(); });
    return;
  }

  // Fallback: resolve via a single product fetch (no retry; see blendersMysteryFetchProduct).
  blendersMysteryFetchProduct(reg.handle)
    .then(function (product) {
      var v = blendersMysteryResolveVariant(product, genderValue, shapeValue);
      if (!v) throw new Error('no variant for ' + (genderValue ? genderValue + ' / ' : '') + shapeValue);
      return addVariant(v.id);
    })
    .catch(function () { revert(); });
};

window.blendersMysteryResetPicker = function (kind) {
  var k = kind || 'mystery';
  var block = blendersMysteryEl(k);
  if (!block) return;
  var genders = ((blendersMysteryBlock(k) || {}).config || {}).genders || [];
  var state = blendersMysteryState(k);
  state.gender = genders.length ? genders[0].key : null;
  state.shape = null;
  block.querySelectorAll('.rebuy-cart__mystery-shape').forEach(function (el) { el.classList.remove('active'); });
  block.querySelectorAll('.rebuy-cart__mystery-gender').forEach(function (el, i) { el.classList.toggle('active', i === 0); });
};

window.__blendersRecentAdds = window.__blendersRecentAdds || {};
var BLENDERS_ATC_CONFIRM_MS = 2000;

function blendersCardHandle(el) {
  var block = el && el.closest && el.closest('.rebuy-product-block');
  var link = block && block.querySelector('a[href*="/products/"]');
  if (!link) return '';
  return (link.getAttribute('href') || '').split('/products/').pop().split('?')[0].split('#')[0];
}

document.addEventListener('pointerdown', function (e) {
  var btn = e.target && e.target.closest &&
    e.target.closest('#rebuy-cart .rebuy-product-actions .rebuy-button');
  if (!btn) return;

  btn.classList.add('blenders-atc-confirmed');
  setTimeout(function () { btn.classList.remove('blenders-atc-confirmed'); }, BLENDERS_ATC_CONFIRM_MS);

  var handle = blendersCardHandle(btn);
  if (handle) {
    if (window.__blendersRecentAdds[handle]) clearTimeout(window.__blendersRecentAdds[handle]);
    window.__blendersRecentAdds[handle] = setTimeout(function () {
      delete window.__blendersRecentAdds[handle];
      if (typeof window.blendersSyncBundleAddons === 'function') window.blendersSyncBundleAddons();
    }, BLENDERS_ATC_CONFIRM_MS);
  }
}, true);

window.blendersSyncBundleAddons = function () {
  var cart = document.getElementById('rebuy-cart');
  if (!cart) return;

  var blocks = cart.querySelectorAll('.rebuy-cart__bundle-body .rebuy-product-block');
  var hasVisible = false; // at least one not-in-cart candidate is shown

  blocks.forEach(function (block) {
    var link = block.querySelector('a[href*="/products/"]');
    var handle = link && (link.getAttribute('href') || '').split('/products/').pop().split('?')[0].split('#')[0];
    var inCart = handle && cart.querySelector('.rebuy-cart__flyout-item--bundle-addon.product-' + handle);

    // Show every add-on that isn't already in the cart; hide the ones that are
    // (they now live up top as line items). No cap — show them all.
    if (!handle || inCart) {
      block.style.setProperty('display', 'none', 'important');
    } else {
      block.style.removeProperty('display');
      hasVisible = true;
    }
  });

  // Show/hide the whole bundle block based on whether any add-on remains to offer.
  // ALWAYS sync the body height to `is-open` so the body and the +/− toggle icon
  // never disagree (removeProperty runs first, so scrollHeight is read while the
  // block is visible). Preserve `is-open` so the widget reopens in the same state.
  var bundle = cart.querySelector('.rebuy-cart__bundle');
  if (!bundle) return;
  if (hasVisible) {
    bundle.style.removeProperty('display');
    // One-shot auto-open on cart-open: if the shopper is UNDER the free-shipping
    // threshold, expand the add-ons to nudge them toward the cheap top-ups. The
    // pending flag is armed by rebuy:cart.show; decide only once the free-shipping
    // indicator has rendered (it carries `is-qualified` at 100% = threshold met),
    // then clear the flag so a manual collapse during this same open isn't overridden.
    if (window.__blendersBundleAutoOpenPending) {
      var shipMsg = cart.querySelector('.rebuy-cart__ship-msg');
      if (shipMsg) {
        if (!shipMsg.classList.contains('is-qualified')) bundle.classList.add('is-open');
        window.__blendersBundleAutoOpenPending = false;
      }
    }
    if (typeof window.blendersSetBundleHeight === 'function') {
      window.blendersSetBundleHeight(bundle, bundle.classList.contains('is-open'));
    }
  } else {
    bundle.style.setProperty('display', 'none', 'important');
  }
};

/* Arm a one-shot bundle auto-open each time the Smart Cart opens. blendersSyncBundleAddons
   consumes the flag once the progress bar is present, opening the bundle only when the
   shopper is under the free-shipping threshold. Fire a few delayed syncs so we catch
   whichever render pass first has both the bundle and the progress bar mounted. */
['rebuy:cart.show', 'rebuy:cart.ready'].forEach(function (evt) {
  document.addEventListener(evt, function () {
    window.__blendersBundleAutoOpenPending = true;
    [0, 200, 600].forEach(function (d) {
      setTimeout(function () {
        if (typeof window.blendersSyncBundleAddons === 'function') window.blendersSyncBundleAddons();
      }, d);
    });
  });
});

/* Keep the tabs in sync with the actual Rebuy widgets: a tab is shown only if
   its panel rendered at least one product. Hiding/emptying a widget in Rebuy
   therefore removes its tab automatically, and clicks never land on an empty
   panel. Re-run whenever the cart DOM changes (widgets load asynchronously). */
window.blendersSyncShopNowTabs = function () {
  var cart = document.getElementById('rebuy-cart');
  if (!cart) return;
  var nav = cart.querySelector('.shop-now-nav');
  var wrap = cart.querySelector('.shop-now-rebuy-products');
  if (!nav || !wrap) return;

  var firstVisibleKey = null;
  var activeStillVisible = false;

  (window.BLENDERS_SHOP_NOW_TABS || []).forEach(function (tab) {
    var li = nav.querySelector('.shop-now-list[data-rebuy-list="' + tab.key + '"]');
    var panel = wrap.querySelector('#shop-now-' + tab.key);
    // products stay in the DOM even when the panel is display:none, so this is reliable
    var hasProducts = !!(panel && panel.querySelector('.rebuy-product-block'));

    if (li) li.style.display = hasProducts ? '' : 'none';
    if (hasProducts) {
      if (firstVisibleKey === null) firstVisibleKey = tab.key;
      if (li && li.classList.contains('active')) activeStillVisible = true;
    }
  });

  // If the active tab is hidden/empty (or nothing is active), fall back to the
  // first populated tab so the picker is never showing an empty panel.
  if (!activeStillVisible && firstVisibleKey) {
    window.blendersShopNowTab(firstVisibleKey);
  }
};

(() => {
  'use strict';
  const TAG = '[AttentiveBootstrap]';
  const QUEUE = [];

  const stubTrigger = function (...args) {
    QUEUE.push(args);
  };

  if (!window.__attentive) {
    window.__attentive = { _isStub: true, trigger: stubTrigger };
  } else if (typeof window.__attentive.trigger !== 'function') {
    window.__attentive.trigger = stubTrigger;
    window.__attentive._isStub = true;
  } else {
    // Real SDK already present — fire the ready event so any listeners that
    // attach later (e.g. section scripts) still resolve.
    window.dispatchEvent(new CustomEvent('attentive:ready', { detail: { elapsedMs: 0 } }));
    return;
  }

  const startedAt = performance.now();
  const POLL = 200;
  const TIMEOUT = 30000;
  const watchdog = setInterval(() => {
    const cur = window.__attentive;
    const elapsed = performance.now() - startedAt;
    const ready = cur && typeof cur.trigger === 'function' && cur.trigger !== stubTrigger;

    if (ready) {
      while (QUEUE.length > 0) {
        const args = QUEUE.shift();
        try {
          cur.trigger(...args);
        } catch (err) {
          console.warn(TAG, 'replay failed for', args, err);
        }
      }
      window.dispatchEvent(new CustomEvent('attentive:ready', { detail: { elapsedMs: Math.round(elapsed) } }));
      clearInterval(watchdog);
      return;
    }

    if (elapsed >= TIMEOUT) {
      console.warn(
        TAG,
        `Attentive SDK never loaded after ${Math.round(elapsed)}ms (likely blocked by an ad-blocker / privacy extension). ` +
          `Newsletter CTA will remain hidden. ${QUEUE.length} queued call(s) discarded.`
      );
      clearInterval(watchdog);
    }
  }, POLL);
})();

(() => {
  'use strict';

  let loaded = false;

  const isSearchTemplate = () => {
    const t = window.Theme && window.Theme.template;
    return t && t.name === 'search';
  };

  const loadRebuy = () => {
    if (loaded) return;
    loaded = true;
    const shop = (window.Shopify && window.Shopify.shop) || window.location.hostname;
    const s = document.createElement('script');
    s.src = `https://cdn.rebuyengine.com/onsite/js/rebuy.js?shop=${shop}`;
    document.body.appendChild(s);
  };

  if (isSearchTemplate()) {
    loadRebuy();
    return;
  }

  const WARM_EVENTS = ['pointerdown', 'pointermove', 'touchstart', 'keydown', 'scroll', 'wheel'];
  const warm = () => {
    WARM_EVENTS.forEach((e) => window.removeEventListener(e, warm));
    loadRebuy();
  };
  WARM_EVENTS.forEach((e) => window.addEventListener(e, warm, { passive: true, once: true }));

  // Fallbacks if the shopper never interacts.
  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadRebuy, { timeout: 4000 });
  } else {
    window.addEventListener('load', () => setTimeout(loadRebuy, 1500), { once: true });
  }
})();

(() => {
  'use strict';

  const ACSB_TRIGGER_CSS =
    '.trigger-button, button[part="acsb-trigger"] {' +
    'width: 40px !important; height: 40px !important;' +
    'min-width: 40px !important; min-height: 40px !important;' +
    'inline-size: 40px !important; block-size: 40px !important;' +
    '}' +
    '@media screen and (max-width: 767px) {' +
    '.trigger-button, button[part="acsb-trigger"], [data-testid="acsb-trigger"] {' +
    'display: none !important;' +
    '}' +
    '}';

  const initAccessibility = () => {
    try {
      const s = document.createElement('script');
      s.src = 'https://acsbapp.com/apps/app/dist/js/app.js';
      s.async = true;
      s.onload = () => {
        if (typeof acsbJS !== 'undefined') {
          acsbJS.init({
            statementLink: '',
            footerHtml: '',
            hideMobile: false,
            hideTrigger: false,
            language: 'en',
            position: 'right',
            leadColor: '#146ff8',
            triggerColor: '#146ff8',
            triggerRadius: 0,
            triggerPositionX: 'right',
            triggerPositionY: 'top',
            triggerIcon: 'people',
            triggerSize: 'medium',
            triggerOffsetX: 0,
            triggerOffsetY: 0,
            mobile: {
              triggerSize: 'small',
              triggerPositionX: 'right',
              triggerPositionY: 'top',
              triggerOffsetX: 0,
              triggerOffsetY: 0,
              triggerRadius: 0,
            },
          });
        }
      };
      s.onerror = () => console.warn('Accessibility script failed to load');
      (document.body || document.querySelector('head')).appendChild(s);
    } catch (error) {
      console.error('Error initializing accessibility:', error);
    }
  };

  const injectAcsbStyle = (root) => {
    if (!root || root.__acsbSizeInjected) return;
    try {
      const style = document.createElement('style');
      style.setAttribute('data-injected', 'acsb-trigger-size');
      style.textContent = ACSB_TRIGGER_CSS;
      root.insertBefore(style, root.firstChild);
      root.__acsbSizeInjected = true;
    } catch (_) {}
  };

  const scanForAcsbShadowRoot = () => {
    const els = document.querySelectorAll('*');
    for (const el of els) {
      if (el.shadowRoot && !el.shadowRoot.__acsbSizeInjected) {
        if (el.shadowRoot.querySelector('[part="acsb-trigger"], [data-testid="acsb-trigger"]')) {
          injectAcsbStyle(el.shadowRoot);
        }
      }
    }
  };

  const acsbObserver = new MutationObserver(scanForAcsbShadowRoot);
  const startAcsbObserver = () => {
    acsbObserver.observe(document.documentElement, { childList: true, subtree: true });
    scanForAcsbShadowRoot();
  };
  if (document.body) {
    startAcsbObserver();
  } else {
    document.addEventListener('DOMContentLoaded', startAcsbObserver, { once: true });
  }
  setTimeout(() => acsbObserver.disconnect(), 120000);

  if ('requestIdleCallback' in window) {
    requestIdleCallback(initAccessibility, { timeout: 10000 });
  } else {
    window.addEventListener('load', () => setTimeout(initAccessibility, 4000), { once: true });
  }
})();

(() => {
  const overlay = document.getElementById('rebuy-search-overlay');
  if (!overlay) return;
  const checkPanel = () => {
    const container = document.querySelector('.rebuy-quick-view-dropdown__container.visible, .rebuy-quick-view-flyout__container.visible');
    overlay.style.display = container ? 'block' : 'none';
  };

  let checkScheduled = false;
  const scheduleCheck = () => {
    if (checkScheduled) return;
    checkScheduled = true;
    requestAnimationFrame(() => {
      checkScheduled = false;
      checkPanel();
    });
  };
  new MutationObserver(scheduleCheck).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
  });
  overlay.addEventListener('click', () => { overlay.style.display = 'none'; });
})();

(() => {
  'use strict';

  const collectionCache = Object.create(null);
  const inflightFetches = Object.create(null);
  const fetchQueue = [];
  let activeRequests = 0;
  const MAX_CONCURRENT_FETCHES = 2;
  const FETCH_INTERVAL_MS = 120;

  const fetchAbortController = new AbortController();
  const cancelInflight = () => {
    try { fetchAbortController.abort(); } catch (_) {}
  };
  window.addEventListener('pagehide', cancelInflight, { once: true });

  const normalizeTags = (rawTags) => {
    if (!rawTags) return [];
    if (Array.isArray(rawTags)) return rawTags;
    if (typeof rawTags === 'string') return rawTags.split(/,\s*/);
    return [];
  };

  const getCollectionFromTags = (tags) => {
    if (!tags || !tags.length) return '';
    for (const tag of tags) {
      if (!tag || tag.indexOf('::') === -1) continue;
      const parts = tag.split('::');
      if ((parts[0] || '').trim().toLowerCase() === 'collection') {
        return (parts[1] || '').trim().replace(/\s*\|\s*rx$/i, '');
      }
    }
    return '';
  };

  const pumpFetchQueue = () => {
    while (activeRequests < MAX_CONCURRENT_FETCHES && fetchQueue.length > 0) {
      const task = fetchQueue.shift();
      activeRequests++;
      // keepalive lets this cosmetic collection-label request finish in the
      // background if the shopper clicks a swatch that also navigates away —
      // otherwise the page unload aborts it as "Failed to fetch" (Noibu #8012).
      // Wire to the shared abort signal so unload-time rejections come back
      // as AbortError instead of "Failed to fetch" — Noibu groups those
      // separately so #8614 stops being reported.
      fetch(`/products/${task.handle}.json`, {
        credentials: 'same-origin',
        keepalive: true,
        signal: fetchAbortController.signal,
      })
        .then((r) => {
          if (!r.ok) throw new Error(`HTTP ${r.status}`);
          return r.json();
        })
        .then((data) => normalizeTags(data && data.product && data.product.tags))
        .then((tags) => {
          const collection = getCollectionFromTags(tags);
          collectionCache[task.handle] = collection;
          task.resolve(collection);
        })
        .catch(() => {
          collectionCache[task.handle] = '';
          task.resolve('');
        })
        .then(() => {
          delete inflightFetches[task.handle];
          setTimeout(() => {
            activeRequests--;
            pumpFetchQueue();
          }, FETCH_INTERVAL_MS);
        });
    }
  };

  const fetchCollectionForHandle = (handle) => {
    if (handle in collectionCache) return Promise.resolve(collectionCache[handle]);
    if (inflightFetches[handle]) return inflightFetches[handle];
    const promise = new Promise((resolve) => {
      fetchQueue.push({ handle, resolve });
      pumpFetchQueue();
    });
    inflightFetches[handle] = promise;
    return promise;
  };

  const ensureCollectionForCard = (card, collection, handle) => {
    if (!card || !card.isConnected) return;
    const existing = card.querySelector('.rebuy-product-collection');

    if (!collection) {
      if (existing) existing.remove();
      return;
    }

    if (existing) {
      if (existing.dataset.rebuyHandle === handle && existing.textContent === collection) return;
      existing.dataset.rebuyHandle = handle;
      existing.textContent = collection;
      return;
    }

    const titleEl = card.querySelector('.rebuy-product-title');
    if (!titleEl) return;
    const p = document.createElement('p');
    p.className = 'rebuy-product-collection';
    p.dataset.rebuyHandle = handle;
    p.textContent = collection;
    titleEl.insertAdjacentElement('afterend', p);
  };

  const resolveTagsFromDataAttr = (card) => {
    const productEl = card.closest('[data-rebuy-product]') || card;
    try {
      const dataAttr = productEl.getAttribute('data-rebuy-product');
      if (dataAttr) {
        const data = JSON.parse(dataAttr);
        return normalizeTags(data.tags);
      }
    } catch (_) {}
    return null;
  };

  const getHandle = (card) => {
    const anchors = card.querySelectorAll('a[href*="_rdiscovery-handle="]');
    for (const a of anchors) {
      const match = (a.getAttribute('href') || '').match(/[?&]_rdiscovery-handle=([^&#]+)/);
      if (match) return decodeURIComponent(match[1]);
    }
    const titleLink = card.querySelector('.rebuy-product-title');
    if (!titleLink) return '';
    const href = titleLink.getAttribute('href') || '';
    return href.split('/products/').pop().split('?')[0].split('#')[0];
  };

  const findInProductArray = (arr, handle) => {
    if (!arr || !arr.length) return null;
    for (const item of arr) {
      if (!item || typeof item !== 'object') continue;
      if (item.handle === handle && item.tags) return normalizeTags(item.tags);
      if (item.products && item.products.length) {
        const inner = findInProductArray(item.products, handle);
        if (inner) return inner;
      }
    }
    return null;
  };

  const resolveTagsFromRebuyState = (handle) => {
    const SS = window.Rebuy && window.Rebuy.SmartSearch;
    const $data = SS && SS.quickView && SS.quickView.view && SS.quickView.view.$data;
    if (!$data) return null;
    for (const key of ['products', 'collections', 'content']) {
      const found = findInProductArray($data[key], handle);
      if (found) return found;
    }
    return null;
  };

  const processCard = (card) => {
    if (!card || !card.isConnected) return;

    const handle = getHandle(card);
    if (!handle) {
      // Card has no resolvable product — drop any stale label.
      const stale = card.querySelector('.rebuy-product-collection');
      if (stale) stale.remove();
      return;
    }

    // If we already labeled this exact handle on this exact card, skip work.
    const existing = card.querySelector('.rebuy-product-collection');
    if (existing && existing.dataset.rebuyHandle === handle) return;

    const tags = resolveTagsFromDataAttr(card);
    if (tags && tags.length) {
      ensureCollectionForCard(card, getCollectionFromTags(tags), handle);
      return;
    }

    if (handle in collectionCache) {
      ensureCollectionForCard(card, collectionCache[handle], handle);
      return;
    }

    const stateTags = resolveTagsFromRebuyState(handle);
    if (stateTags && stateTags.length) {
      const collection = getCollectionFromTags(stateTags);
      collectionCache[handle] = collection;
      ensureCollectionForCard(card, collection, handle);
      return;
    }

    if (existing) existing.remove();

    fetchCollectionForHandle(handle).then((collectionName) => {
      if (!card.isConnected) return;
      if (getHandle(card) !== handle) return;
      ensureCollectionForCard(card, collectionName, handle);
    });
  };

  const processQuickViewCards = (root) => {
    const scope = (root && root.querySelectorAll) ? root : document;
    scope.querySelectorAll('.rebuy-quick-view__product').forEach(processCard);
    if (root && root.classList && root.classList.contains('rebuy-quick-view__product')) {
      processCard(root);
    }
  };

  // Smart Cart recommendation cards reuse the same collection-title engine as
  // quick-view / smart-search. Rebuy puts the collection on the card as a
  // `tag-collection*` class (same source the cart line-items use), so resolve
  // it synchronously here — instant, no /products/*.json fetch needed. Fall
  // back to the fetch-based processCard when no class is present.
  const collectionFromCardClass = (card) => {
    const m = (card.className || '').match(/(?:^|\s)tag-collection([^\s]+)/);
    return m ? m[1].replace(/-/g, ' ').trim() : '';
  };

  const processSmartCartCards = () => {
    document.querySelectorAll('#rebuy-cart .rebuy-product-block').forEach((card) => {
      // Bundle add-on rows show no model line (per design) — skip them.
      if (card.closest('.rebuy-cart__bundle-body')) return;
      const fromClass = collectionFromCardClass(card);
      if (fromClass) {
        ensureCollectionForCard(card, fromClass, getHandle(card));
      } else {
        processCard(card);
      }
    });
  };

  const runInjection = (root) => {
    processQuickViewCards(root);
    processSmartCartCards();
    requestAnimationFrame(() => {
      processQuickViewCards(root);
      processSmartCartCards();
      if (typeof window.blendersSyncShopNowTabs === 'function') window.blendersSyncShopNowTabs();
      if (typeof window.blendersSyncBundleAddons === 'function') window.blendersSyncBundleAddons();
    });
  };

  window.__blendersInjectCollectionTitles = runInjection;

  const attachVueWatchers = () => {
    const SS = window.Rebuy && window.Rebuy.SmartSearch;
    const view = SS && SS.quickView && SS.quickView.view;
    if (!view || typeof view.$watch !== 'function') return false;
    if (view.__blendersWatchersAttached) return true;
    view.__blendersWatchersAttached = true;

    const flush = () => {
      view.$nextTick(() => {
        runInjection();
        setTimeout(runInjection, 80);
        setTimeout(runInjection, 250);
        setTimeout(runInjection, 600);
      });
    };

    view.$watch('isQuickViewOpen', (isOpen) => { if (isOpen) flush(); });
    view.$watch('products', flush, { deep: false });
    view.$watch('content', flush, { deep: false });
    view.$watch('collections', flush, { deep: false });

    view.$watch('quickViewSearchLoading', (isLoading) => {
      document.body.classList.toggle('blenders-rebuy-loading', !!isLoading);
      if (!isLoading) flush();
    });
    if (view.quickViewSearchLoading) {
      document.body.classList.add('blenders-rebuy-loading');
    }

    if (view.isQuickViewOpen) flush();
    return true;
  };

  if (!attachVueWatchers()) {
    let attempts = 0;
    const poll = setInterval(() => {
      attempts++;
      if (attachVueWatchers() || attempts >= 50) clearInterval(poll);
    }, 200);
  }

  let scanScheduled = false;
  const scheduleFullScan = () => {
    if (scanScheduled) return;
    scanScheduled = true;
    requestAnimationFrame(() => {
      scanScheduled = false;
      document.querySelectorAll('.rebuy-quick-view__product').forEach(processCard);
      processSmartCartCards();
      if (typeof window.blendersSyncShopNowTabs === 'function') window.blendersSyncShopNowTabs();
      if (typeof window.blendersSyncBundleAddons === 'function') window.blendersSyncBundleAddons();
    });
  };

  new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const n of m.addedNodes) {
        if (!n || n.nodeType !== 1) continue;
        // Ignore our own injected collection labels so they don't re-trigger the scan.
        if (n.classList && n.classList.contains('rebuy-product-collection')) continue;
        scheduleFullScan();
        break;
      }
      for (const r of m.removedNodes) {
        if (!r || r.nodeType !== 1) continue;
        if (r.classList && r.classList.contains('rebuy-product-collection')) {
          scheduleFullScan();
          break;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  runInjection();
})();
